var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0\" y=\"0\" viewbox=\"0 0 40 20\" xml:space=\"preserve\" class=\"quote-angle\"><path d=\"M0,-1V0c6.6,0,11.1,6.2,9.9,13.6c-0.2,1.6,0.8,2.4,1.6,2.4c1,0,1.6-0.6,2.3-1.6C19.9,5.2,30,0,40,0V-1H0z\" class=\"quote-angle-side quote-angle-below-left\"></path><path d=\"M40,-1V0c-6.6,0-11.1,6.2-9.9,13.6c0.2,1.6-0.8,2.4-1.6,2.4c-1,0-1.6-0.6-2.3-1.6C20.1,5.2,10,0,0,0V-1L40,-1z\" class=\"quote-angle-side quote-angle-below-right\"></path></svg>");;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}